import React, { useState, useEffect } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import LogoIcon from '../../svg/LogoIcon';
import Button from '../Button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={`sticky top-0 transition-all duration-300 ${
        isScrolled 
          ? 'glass-effect shadow-lg' 
          : 'bg-transparent'
      }`} 
      style={{ zIndex: 999, width: '100%' }}
    >
      <div className="container flex flex-col sm:flex-row justify-between items-center mx-auto py-4 px-8">
        <div className="flex items-center text-2xl">
          <div className="w-24 mr-3">
            <LogoIcon />
          </div>
        </div>
        
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          <AnchorLink 
            className={`px-4 py-2 transition-colors duration-300 font-medium ${
              isScrolled 
                ? 'text-gray-700 hover:text-indigo-600' 
                : 'text-white/90 hover:text-white'
            }`} 
            href="#features"
          >
            Expertise
          </AnchorLink>
          <AnchorLink 
            className={`px-4 py-2 transition-colors duration-300 font-medium ${
              isScrolled 
                ? 'text-gray-700 hover:text-indigo-600' 
                : 'text-white/90 hover:text-white'
            }`} 
            href="#portfolio"
          >
            Trabalhos
          </AnchorLink>
          <AnchorLink 
            className={`px-4 py-2 transition-colors duration-300 font-medium ${
              isScrolled 
                ? 'text-gray-700 hover:text-indigo-600' 
                : 'text-white/90 hover:text-white'
            }`} 
            href="#partners"
          >
            Parceiros
          </AnchorLink>
          <AnchorLink 
            className={`px-4 py-2 transition-colors duration-300 font-medium ${
              isScrolled 
                ? 'text-gray-700 hover:text-indigo-600' 
                : 'text-white/90 hover:text-white'
            }`} 
            href="#stats"
          >
            Resultados
          </AnchorLink>
        </nav>
        
        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <svg className={`w-6 h-6 ${isScrolled ? 'text-gray-700' : 'text-white'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {isMobileMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
        
        <div className="hidden md:block">
          <a href="mailto:contato@oxton.com.br?Subject=Contato">
            <Button className={`text-sm ${
              isScrolled 
                ? 'bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700' 
                : 'bg-white/20 backdrop-blur-sm border border-white/30 text-white hover:bg-white/30'
            }`}>
              Fale conosco
            </Button>
          </a>
        </div>
      </div>
      
      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className={`md:hidden ${isScrolled ? 'glass-effect border-t border-gray-200' : 'glass-effect-dark border-t border-white/20'}`}>
          <nav className="flex flex-col py-4">
            <AnchorLink 
              className={`px-8 py-3 transition-colors duration-300 ${
                isScrolled 
                  ? 'text-gray-700 hover:text-indigo-600 hover:bg-gray-50' 
                  : 'text-white/90 hover:text-white hover:bg-white/10'
              }`} 
              href="#features"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Expertise
            </AnchorLink>
            <AnchorLink 
              className={`px-8 py-3 transition-colors duration-300 ${
                isScrolled 
                  ? 'text-gray-700 hover:text-indigo-600 hover:bg-gray-50' 
                  : 'text-white/90 hover:text-white hover:bg-white/10'
              }`} 
              href="#portfolio"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Trabalhos
            </AnchorLink>
            <AnchorLink 
              className={`px-8 py-3 transition-colors duration-300 ${
                isScrolled 
                  ? 'text-gray-700 hover:text-indigo-600 hover:bg-gray-50' 
                  : 'text-white/90 hover:text-white hover:bg-white/10'
              }`} 
              href="#partners"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Parceiros
            </AnchorLink>
            <AnchorLink 
              className={`px-8 py-3 transition-colors duration-300 ${
                isScrolled 
                  ? 'text-gray-700 hover:text-indigo-600 hover:bg-gray-50' 
                  : 'text-white/90 hover:text-white hover:bg-white/10'
              }`} 
              href="#stats"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Resultados
            </AnchorLink>
            <div className="px-8 py-3">
              <a href="mailto:contato@oxton.com.br?Subject=Contato">
                <Button className={`w-full text-sm ${
                  isScrolled 
                    ? 'bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700' 
                    : 'bg-white/20 backdrop-blur-sm border border-white/30 text-white hover:bg-white/30'
                }`}>
                  Fale conosco
                </Button>
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
